// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mZ5E","col":"styles_col__3UxY9"};